"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = require("react"),
    LeftArrow = function LeftArrow(_a) {
  var customLeftArrow = _a.customLeftArrow,
      getState = _a.getState,
      previous = _a.previous;
  return customLeftArrow ? React.cloneElement(customLeftArrow, {
    onClick: function onClick() {
      return previous();
    },
    carouselState: getState()
  }) : React.createElement("button", {
    "aria-label": "Go to previous slide",
    className: "react-multiple-carousel__arrow react-multiple-carousel__arrow--left",
    onClick: function onClick() {
      return previous();
    }
  });
};

exports.LeftArrow = LeftArrow;

var RightArrow = function RightArrow(_a) {
  var customRightArrow = _a.customRightArrow,
      next = _a.next,
      getState = _a.getState;
  return customRightArrow ? React.cloneElement(customRightArrow, {
    onClick: function onClick() {
      return next();
    },
    carouselState: getState()
  }) : React.createElement("button", {
    "aria-label": "Go to next slide",
    className: "react-multiple-carousel__arrow react-multiple-carousel__arrow--right",
    onClick: function onClick() {
      return next();
    }
  });
};

exports.RightArrow = RightArrow;